import React, { useMemo } from "react";
import { useRecoilValue } from "recoil";
import { CampaignActionAtom } from "../../../../atoms/CampaignActionAtom";
import {
  CampaignScreen,
  CampaingBuilderFormAtom,
} from "../../../../atoms/CampaingBuilderFormAtom";
import { NodeIndexAtom } from "../../../../atoms/NodeIndexAtom";
import ApplyTag from "./ManageTag";
import Email from "./Email";
import { DefaultFormProps } from "./Form";
import PushNotification from "./PushNotification";
import SmsNotification from "./SmsNotification";
import WebHook from "./Webhook";
import styled from "@emotion/styled";

const Container = styled.div`
  max-width: 1000px;
  width: 100%;

  @media screen and (max-width: 1080px) {
    min-width: 480px;
    /* height: calc(100vh - 87px);

    position: absolute;
    top: 0;
    bottom: 0;
    right: 0; */
  }
`;

const FormRouter = () => {
  const screen = useRecoilValue(CampaingBuilderFormAtom);
  const nodeIndex = useRecoilValue(NodeIndexAtom);
  const action = useRecoilValue(CampaignActionAtom);

  const CurrentScreen: ((props: DefaultFormProps) => JSX.Element) | null =
    useMemo(() => {
      switch (screen) {
        case CampaignScreen.TAG:
          return ApplyTag;
        case CampaignScreen.EMAIL:
          return Email;
        case CampaignScreen.WEBHOOK:
          return WebHook;
        case CampaignScreen.PUSH_NOTIFICATION:
          return PushNotification;
        case CampaignScreen.SMS_NOTIFICATION:
          return SmsNotification;
        default:
          return null;
      }
    }, [screen]);

  return CurrentScreen ? (
    <Container>
      <CurrentScreen
        {...{
          action,
          nodeIndex,
          initial: nodeIndex === -1,
          stopCampaign: nodeIndex === -2,
        }}
      />
    </Container>
  ) : null;
};

export default FormRouter;
